module.exports = __webpack_public_path__ + "img/24.3.TP.01de71dc.png";